<template>
  <view-wrapper
    name="Standard labels"
    :loading="loading"
    :loadingText="loadingText"
  >
    <router-link
      class="mt-3 mb-12 button big primary white"
      to="/standardlabels/new"
      >Create new</router-link
    >

    <modal
      v-if="confirmDeleteOpen"
      @close="confirmDeleteOpen = !confirmDeleteOpen"
      type="warning"
    >
      <template slot="body">
        <h3>Are you sure?</h3>
        <p>This action cannot be reverted</p>
      </template>
      <template slot="buttons">
        <grafokett-button
          class="mb-2 button big primary white"
          @click="confirmDeleteOpen = !confirmDeleteOpen"
          >Cancel</grafokett-button
        >
        <grafokett-button
          class="mb-2 button big primary white"
          @click="deleteLabel()"
          >Delete</grafokett-button
        >
      </template>
    </modal>

    <expandabel-table
      :useSearch="false"
      :columnsToNotSort="columnsToNotSort"
      :data="standardLabels"
      :headers="headers"
    >
      <template v-slot:child="{ child }">
        <div class="text-right">
          <router-link
            :to="`/standardlabels/${child.parentId}`"
            class="button small"
            >Edit <i class="text-lg edit-symbol"
          /></router-link>
          <grafokett-button class="small" @click="openConfirmModal(child)"
            >Delete</grafokett-button
          >
        </div>
        <p class="mb-5">Variabels</p>
        <div v-for="(v, index) in child.variabels" :key="'var' + index">
          <div>
            <p class="flex-1">{{ v.key }}</p>
            <div class="flex p-3 rounded bg-primary-light">
              <span class="flex-1">{{ v.data }}</span>
            </div>
          </div>
        </div>
      </template>
    </expandabel-table>
  </view-wrapper>
</template>

<script>
import GrafokettButton from "../components/forms/Button.vue";
import ExpandabelTable from "../components/ExpandabelTable";
import Modal from "../components/Modal";

export default {
  components: {
    Modal,
    GrafokettButton,
    ExpandabelTable
  },
  data() {
    return {
      headers: {
        name: "Name",
        type: "Type"
      },
      columnsToNotSort: ["arrow"],
      loading: false,
      loadingText: "List of labels",
      warningText: "",
      labelToDelete: null,
      confirmDeleteOpen: false
    };
  },
  computed: {
    allLabels() {
      return this.$store.getters["LABELS/LABELS"].map(l => {
        return {
          id: l.labelId,
          name: l.name,
          type: l.type,
          disabled: l.disabled,
          modified: new Date(l.modified).toLocaleDateString("sv-SE"),
          expandableData: {
            variabels: l.variables.map(v => {
              return {
                name: v.name,
                description: v.propertyDescription,
                length: v.propertySize,
                IsFixedLength: v.propertySize !== 0,
                locked: !v.editable,
                boundToName: !v.boundToId
                  ? v.name
                  : l.variables.filter(e => e.id === v.boundToId)[0].name
              };
            }),
            groups: l.groups
          }
        };
      });
    },
    labels() {
      return this.allLabels.filter(l => !l.disabled);
    },
    standardLabels() {
      return this.$store.getters["LABELS/STANDARD_LABELS"].map(l => {
        const labelData = [];

        for (var o in l) {
          if (o === "id" || o === "name" || o === "labelId") continue;
          labelData[labelData.length] = {
            key: o,
            data: l[o]
          };
        }

        return {
          id: l.id,
          name: l.name,
          type: l.type,
          expandableData: {
            variabels: labelData
          }
        };
      });
    }
  },
  methods: {
    async getData() {
      await this.$store.dispatch("LABELS/GET_STANDARD_LABELS");
      await this.$store.dispatch("LABELS/GET_LABELS");
    },
    async deleteLabel() {
      this.confirmDeleteOpen = false;
      this.loading = true;
      await this.$store.$api.delete(
        `/api/labels/standardlabels/${this.labelToDelete.parentId}`
      );
      this.labelToDelete = null;
      this.getData();
      this.loading = false;
    },
    openConfirmModal(labelToDelete) {
      this.confirmDeleteOpen = true;
      this.labelToDelete = labelToDelete;
    }
  },
  async mounted() {
    this.loading = true;
    await this.getData();
    this.loading = false;
  }
};
</script>
